import { Avatar } from '@components/avatar';
import { ForemanProps } from './types';
import { cn } from '@utils/cn';
import { useTranslation } from 'react-i18next';
import { SvgConsumer } from '@components/icons/svgConsumer';
import { AppTooltip } from '../tooltip/tooltip';
import { ReactNode } from 'react';

export const Foreman = ({ data, type }: ForemanProps) => {
  const { t } = useTranslation('app');

  if (!data) return null;

  const { fullName, foremanSpecialties, discardedAt } = data;
  const specialties = foremanSpecialties
    ? foremanSpecialties.map((el) => t(`specialty.${el}`)).join(', ')
    : undefined;

  const getColor = () => {
    if (discardedAt) return 'bg-neutral-300';
    if (fullName) return 'bg-primary-300';
    return 'bg-neutral-200';
  };

  const getName = () => {
    if (discardedAt) return;
    if (fullName) return fullName;
    return '?';
  };

  const withTooltip = (component: ReactNode) => {
    if (!discardedAt) return component;
    return (
      <AppTooltip side="bottom" align="start" context={<span>{t('pages.users.removed')}</span>}>
        {component}
      </AppTooltip>
    );
  };

  return (
    <div className="flex h-full w-full items-center gap-2">
      {withTooltip(
        <div className="h-6 w-6">
          <Avatar
            name={getName()}
            hideTooltip
            className={cn([
              'h-6 w-6 select-none text-xs',
              getColor(),
              discardedAt && 'cursor-help',
            ])}>
            {discardedAt && <SvgConsumer className="ml-[2px] shrink-0 text-sm" id="removedUser" />}
          </Avatar>
        </div>,
      )}
      <div className="flex flex-col truncate">
        <span
          className={cn([
            'truncate text-sm font-semibold',
            fullName && !discardedAt ? 'text-neutral-600' : 'text-neutral-400',
          ])}>
          {fullName || t('pages.foreman.scheduledWithoutTeam')}
        </span>
        {(type || specialties) && (
          <span
            className="truncate text-[10px] leading-3 text-neutral-400"
            title={specialties ? specialties : undefined}>
            {specialties || t(`specialty.${type}`)}
          </span>
        )}
      </div>
    </div>
  );
};
